let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3GEC7")).then(() => parcelRequire('sbCtV'));